import Box from "@/elements/Box";
import Button from "@/elements/Button";
import { Container } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface BottomNavigationProps {
  activeStep: number;
  isStep1Valid: boolean;
  isStepFinalValid: boolean;
  isCreating: boolean;
  isUpdatingContact: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export function BottomNavigation({
  activeStep,
  isStep1Valid,
  isStepFinalValid,
  isCreating,
  isUpdatingContact,
  onBack,
  onNext,
  onSubmit,
}: BottomNavigationProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "#ffffff",
        borderTop: "1px solid #e0e0e0",
        boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.15)",
        zIndex: 100,
        backdropFilter: "blur(0px)",
      }}
    >
      <Container maxWidth="md">
        <Box
          display="flex"
          justifyContent={activeStep > 0 ? "space-between" : "flex-end"}
          sx={{ py: 3, gap: 2 }}
        >
          {activeStep > 0 && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={onBack}
              disabled={isCreating || isUpdatingContact}
              startIcon={<ArrowBack />}
              size="large"
              sx={{ flex: 1 }}
            >
              {t("richiestaPreventivo.nav.back")}
            </Button>
          )}

          {activeStep === 4 ? (
            isStepFinalValid ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={onSubmit}
                disabled={isCreating}
                size="large"
                sx={{ flex: 1 }}
              >
                {isCreating
                  ? t("richiestaPreventivo.nav.calculating")
                  : t("richiestaPreventivo.nav.calculate")}
              </Button>
            ) : null
          ) : (activeStep === 1 && isStep1Valid) || activeStep > 1 ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={onNext}
              endIcon={<ArrowForward />}
              size="large"
              sx={{ flex: activeStep > 0 ? 1 : "auto" }}
            >
              {t("richiestaPreventivo.nav.next")}
            </Button>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
